import axios from 'axios'
import store from '../vuex/index'
import { getInstance } from '../auth'

export default function setup () {
  axios.interceptors.request.use(async (config) => {
    const authInstance = getInstance()
    let token
    var isError = false

    // this will fail if the user hits refresh on the browser
    try { token = await authInstance.getTokenSilently() }
    catch { isError = true }
    
    // in that event, resort to the cached access token
    if (isError) {
      token = store.state.accessToken
    } else {
      store.dispatch('updateAccessToken', token)
    }
    
    config.headers.Authorization = `Bearer ${token}`
    return config
  }, () => {
    store.dispatch('logout')
  })
}
